import React from 'react'
import { Block } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import './style.css'

const APLINK = import.meta.env.VITE_API_URL

const Gallery = ({ galleryImages }) => {
    return (
        <Block isRender={galleryImages?.length > 0}>
            <SectionCard icon="mdi:image-multiple" titleKey="gallery">
                <div className="gallery-grid">
                    {galleryImages?.map(image => (
                        <div key={image.id} className="gallery-item">
                            <img 
                                src={image.url} 
                                alt={image.caption}
                                className="gallery-image"
                                onError={(e) => e.target.src = './images/placeholder.jpg'}
                            />
                            <div className="gallery-caption">{image.caption}</div>
                        </div>
                    ))}
                </div>
            </SectionCard>
        </Block>
    )
}

export default Gallery

